import flatpickr from "flatpickr";
import { Japanese } from "flatpickr/dist/l10n/ja.js"
/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  var $trip = $("input[name='trip-other']");
  var $location = $("input[name='location-other']");
  var $radioTrip = $("input[name='trip[]']");
  var $radioLocation = $("input[name='location[]']");

  $trip.prop("disabled", true);
  $location.prop("disabled", true);

  $radioTrip.on("click", function () {
    $trip.prop("disabled", !$(this).prop("checked"));
  });

  $radioLocation.on("click", function () {
    $location.prop("disabled", !$(this).prop("checked"));
  });
});

jQuery(function($) {
  $('#rating-star input:radio').on('change', function(){
    $('#rating-star .wpcf7-list-item').removeClass('checked');
    if ( $(this).prop('checked') ){
      $(this).closest('.wpcf7-list-item').addClass('checked');
    }
  });
});

jQuery(function($) {
  flatpickr.localize(Japanese);
  flatpickr('.form-flatpickr');
});
